// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"ff4eae4c","531":"4d31c245","640":"d35bbb18","674":"ba2b10ef","806":"f41b5359","930":"7d96be41","967":"65b0ff67"}[chunkId] + ".chunk.js";
};